/**
 * @typedef {(args: any[], actionType: string, res: any, triggerElement?: HTMLElement) => void} DashboardActionHandler
 */

/**
 * @class BaseEntity
 */
export default class BaseEntity {

	/** @type {string} */
	#name;
	/** @type {{ [key: string]: any; }} */
	#config;
	actions = {

		// Reload the header section
		/** @type {DashboardActionHandler} */
		reload_header: () => {
			mpro.actionHandlers.reload_header();
		},

		// Reload the container section of the triggerElement
		/** @type {DashboardActionHandler} */
		reload_container: (args, actionType, res, triggerElement) => {
			// Use provided selector or the triggerElement
			mpro.actionHandlers.reload_container(args, actionType, res, triggerElement);
		},

		// Reload the active modal container
		/** @type {DashboardActionHandler} */
		reload_modal: (args, actionType, res, triggerElement) => {
			// Use provided selector or the triggerElement
			mpro.actionHandlers.reload_modal(args, actionType, res, triggerElement);
		},

		// Reload the active drawer container
		/** @type {DashboardActionHandler} */
		reload_drawer: (args, actionType, res, triggerElement) => {
			// Use provided selector or the triggerElement
			mpro.actionHandlers.reload_drawer(args, actionType, res, triggerElement);
		},

		// Reload the container section of the triggerElement
		/** @type {DashboardActionHandler} */
		reload_sections: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.reload_sections(args);
		},

		// Refresh the whole page
		/** @type {DashboardActionHandler} */
		reload_page: () => {
			mpro.actionHandlers.reload_page();
		},

		// Refresh the whole page if the cart is empty
		/** @type {DashboardActionHandler} */
		refresh_if_empty: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.refresh_if_empty(args, actionType, res, triggerElement);
		},

		// Remove the closest parent
		/** @type {DashboardActionHandler} */
		remove_closest: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.remove_closest(args, actionType, res, triggerElement);
		},

		// Show cart confirmation in a toast notification
		/** @type {DashboardActionHandler} */
		toast_notification: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.toast_notification(args, actionType, res, triggerElement);
		},

		// Show message below the button
		/** @type {DashboardActionHandler} */
		inline_notification: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.inline_notification(args, actionType, res, triggerElement);
		},

		// Close the modal that the element belongs to
		/** @type {DashboardActionHandler} */
		close_modal: () => {
			mpro.actionHandlers.close_modal();
		},

		// Close the drawer that the element belongs to
		/** @type {DashboardActionHandler} */
		close_drawer: () => {
			mpro.actionHandlers.close_drawer();
		},

		// Close the drawer that the element belongs to
		/** @type {DashboardActionHandler} */
		close_overlay: () => {
			mpro.actionHandlers.close_overlay();
		},
	};

	constructor() {
		/** @type {any} */
		const ctr = this.constructor;
		this.#name = ctr.NAME.toLowerCase();
	}

	get config() {
		if (!this.#config) {
			this.#config = mpro.config[this.#name];
		}
		return this.#config;
	}

	/**
	 * @param {{ [key: string]: any; }} extraOptions
	 */
	getOverrideActions(extraOptions) {
		return mpro.getOverrideActions(this.#name, ['Success', 'Error'], extraOptions);
	}

	/**
	 * @param {string} actionType
	 * @param {HTMLElement} triggerElement
	 * @param {*} res
	 * @param {{ desktop?: string[]; mobile?: string[] }} overrideActions
	 */
	runSuccessHandlers(actionType, res, triggerElement, overrideActions = {}) {
		mpro.runSuccessHandlers(this.#name, this.actions, actionType, res, triggerElement, overrideActions);
	}

	/**
	 * @param {string} actionType
	 * @param {HTMLElement} triggerElement
	 * @param {*} err
	 * @param {{ desktop?: string[]; mobile?: string[] }} overrideActions
	 */
	runErrorHandlers(actionType, err, triggerElement, overrideActions = {}) {
		mpro.runErrorHandlers(this.#name, this.actions, actionType, err, triggerElement, overrideActions);
	}
}
